import axios from 'axios';

const config = {
  baseURL: `${process.env.VUE_APP_BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
};

/** Creating the instance for axios */
const httpClient = axios.create(config);

export default httpClient;
